import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { blue, indigo } from "@mui/material/colors";

// Pages
import SearchEnroll from "./pages/SearchEnroll/SearchEnroll";
import ApprovedVendors from "./pages/ApprovedVendors/ApprovedVendors";

// Components
import ScrollToTop from "./components/ScrollToTop";

// Theme configuration
const theme = createTheme({
  palette: {
    primary: {
      main: blue[900],
    },
    secondary: {
      main: indigo[700],
    },
  },
  typography: {
    fontFamily: ['"Lato"', "sans-serif"].join(","),
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <ScrollToTop>
          <Routes>
            <Route path="/search-enroll/:employerId/:empState/approved-vendor" element={<ApprovedVendors />} />
            <Route path="/search-enroll/:employerId" element={<SearchEnroll />} />
            <Route path="/search-enroll" element={<SearchEnroll />} />
            <Route path="*" element={<Navigate to="/search-enroll" />} />
          </Routes>
        </ScrollToTop>
      </Router>
    </ThemeProvider>
  );
}

export default App;
